{
  "nav": {
    "theSpace": "El Espacio",
    "schedule": "Horario",
    "practices": "Prácticas",
    "masters": "Maestros",
    "community": "Comunidad",
    "fund": "Fondo",
    "chats": "Chats",
    "myCalendar": "Mi Calendario",
    "feed": "Feed",
    "profile": "Perfil",
    "messages": "Mensajes",
    "notifications": "Notificaciones",
    "discussion": "Debate",
    "guestRoom": "Invitado de la sesión en vivo",
    "dashboard": "Panel",
    "studio": "Estudio",
    "settings": "Configuración",
    "aboutPlatform": "Sobre la plataforma",
    "favorites": "Favoritos",
    "calendar": "Calendario"
  },
  "menu": {
    "appearance": "Apariencia",
    "language": "Idioma",
    "logout": "Cerrar sesión",
    "login": "Iniciar sesión",
    "masterBadge": "MAESTRO"
  },
  "pageTitle": {
    "download": "Descargar la app",
    "default": "Agapella — conocimiento, prácticas y eventos en vivo",
    "home": "El Espacio",
    "news": "Noticias",
    "newsArticle": "Artículo",
    "landing": "Prácticas en vivo 24/7",
    "referralLanding": "Invitación",
    "login": "Iniciar sesión",
    "register": "Registro",
    "confirmEmail": "Confirmar correo",
    "forgotPassword": "Recuperar contraseña",
    "resetPassword": "Nueva contraseña",
    "dashboard": "Panel",
    "me": "Mi perfil",
    "masters": "Maestros",
    "masterDetail": "Perfil del maestro",
    "masterSubscriptions": "Suscripciones",
    "programPurchase": "Compra del programa",
    "programPage": "Programa",
    "agapeCenter": "Centro Agapē",
    "lives": "Horario",
    "eventsCalendar": "Calendario",
    "eventsAll": "Todos los eventos",
    "eventsFilters": "Filtros",
    "eventDetail": "Evento",
    "createEvent": "Crear evento",
    "eventParticipants": "Participantes",
    "schedule": "Horario",
    "upcoming": "Próximos",
    "practices": "Prácticas",
    "practiceDetail": "Práctica",
    "uploadPractice": "Subir práctica",
    "myCollection": "Mi colección",
    "settings": "Configuración",
    "liveDetail": "Sesión en vivo",
    "liveBroadcast": "Sesión en vivo",
    "chats": "Chats",
    "chatThread": "Chat",
    "community": "Comunidad",
    "publicUserProfile": "Perfil",
    "publicUserPost": "Publicación",
    "gamificationShare": "Camino de Luz",
    "circleChat": "Círculo",
    "about": "Acerca de",
    "aboutPlatform": "Sobre la plataforma",
    "environment": "Entorno",
    "gamificationPreview": "Vista previa QA de gamificación",
    "support": "Soporte",
    "contact": "Contacto",
    "notificationSettings": "Notificaciones",
    "securitySettings": "Seguridad",
    "blockedUsers": "Usuarios bloqueados",
    "myCalendar": "Mi calendario",
    "myLibrary": "Mi biblioteca",
    "memoryFacts": "Lo que recuerdo de ti",
    "fund": "Fondo Agápe",
    "finance": "Finanzas",
    "financeDocuments": "Mis documentos",
    "agapellaSubscription": "Suscripción Agapēlla",
    "fundDistribution": "Tu distribución",
    "howItWorks": "Cómo funciona",
    "fundTransparency": "Transparencia del fondo",
    "referralCredits": "Créditos de referidos",
    "fundOnboarding": "Bienvenido al Fondo Agápe",
    "masterWallet": "Cartera",
    "docs": "Documentación",
    "legalDoc": "Documento legal",
    "mission": "La misión de Agapella",
    "ethicsCode": "Código de ética de Agapella",
    "custDev": "CustDev",
    "soundLibrary": "Biblioteca de sonidos",
    "practiceRooms": "Sesiones en vivo",
    "createLiveSession": "Nueva sesión en vivo",
    "liveSessionEntry": "Entrar a la sesión",
    "liveRoomSession": "Sesión en vivo",
    "roomAnnouncement": "Detalles de la sesión",
    "agapePractice": "La práctica Agapē",
    "eventThread": "Debate",
    "feed": "Feed",
    "guestRoom": "Invitado de la sesión en vivo",
    "masterSales": "Ventas",
    "masterAnalytics": "Analítica",
    "notifications": "Notificaciones",
    "payoutDetails": "Datos de pago"
  },
  "feed": {
    "empty": "Tu feed está vacío por ahora"
  },
  "favorites": {
    "filter": {
      "all": "Todo",
      "events": "Eventos",
      "practices": "Prácticas",
      "masters": "Maestros",
      "myRooms": "Mis sesiones en vivo"
    },
    "empty": {
      "all": "Nada en favoritos todavía. Toca el corazón en cualquier tarjeta para añadirla aquí.",
      "events": "Sin eventos en favoritos. Toca el corazón en la tarjeta de un evento.",
      "practices": "Sin prácticas en favoritos. Toca el corazón en cualquier práctica.",
      "masters": "Sin suscripciones aún. Sigue a un maestro para verlo aquí.",
      "myRooms": "Las grabaciones de tus sesiones en vivo aparecerán aquí después de tu primera práctica."
    },
    "unsave": "Quitar de favoritos"
  },
  "masterEvents": {
    "heading": "Eventos del maestro",
    "filter": {
      "all": "Todos",
      "livestream": "Sesiones en vivo",
      "offline": "Presenciales",
      "livepractice": "Prácticas en vivo"
    },
    "empty": {
      "all": "Sin eventos programados.",
      "livestream": "Sin próximas sesiones en vivo.",
      "offline": "Sin próximos encuentros presenciales.",
      "livepractice": "Sin sesiones en vivo abiertas."
    }
  },
  "state": {
    "loading": "Cargando…",
    "error": "Algo salió mal",
    "empty": "Todavía vacío",
    "retry": "Intentar de nuevo"
  },
  "buttons": {
    "logIn": "INICIAR SESIÓN",
    "signIn": "INICIAR SESIÓN",
    "signUp": "REGISTRARSE",
    "logOut": "CERRAR SESIÓN",
    "joinPractice": "IR A LA PRÁCTICA",
    "joinLiveNow": "UNIRSE EN VIVO",
    "classSchedule": "HORARIO DE CLASES",
    "viewAll": "VER TODO",
    "retry": "REINTENTAR",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "GUARDAR",
    "back": "ATRÁS",
    "next": "SIGUIENTE",
    "finish": "FINALIZAR",
    "accept": "Aceptar",
    "decline": "Rechazar",
    "notNow": "Ahora no",
    "explore": "Explorar",
    "sendMessage": "ENVIAR MENSAJE",
    "message": "MENSAJE",
    "sending": "ENVIANDO...",
    "hide": "Ocultar",
    "goBack": "VOLVER",
    "tryAgain": "INTENTAR DE NUEVO",
    "browseLibrary": "EXPLORAR BIBLIOTECA",
    "explorePractices": "EXPLORAR PRÁCTICAS",
    "exploreSchedule": "EXPLORAR HORARIO",
    "create": "Crear",
    "createA11y": "Crear",
    "quickRoom": "Sala rápida",
    "quickRoomShort": "Rápida",
    "quickRoomA11y": "Crear sala rápida",
    "liveSession": "Sesión en vivo",
    "liveSessionShort": "Live",
    "liveSessionA11y": "Crear una sesión en vivo",
    "myCalendarUpper": "MI CALENDARIO",
    "linkCopied": "Enlace copiado",
    "done": "Listo"
  },
  "theme": {
    "mode": "Modo {{mode}}"
  },
  "footer": {
    "tagline1": "Maestros, sesiones en vivo, comunidades, eventos – 24/7",
    "tagline2": "Una plataforma para quienes eligen ser humanos en la práctica",
    "platform": "Plataforma",
    "company": "Compañía",
    "legal": "Legal",
    "about": "Acerca de",
    "contact": "Contacto",
    "careers": "Carreras",
    "termsOfUse": "Términos de uso",
    "privacyPolicy": "Política de Privacidad",
    "aiNotice": "Aviso sobre IA",
    "cookieSettings": "Configuración de cookies",
    "streamingAgreement": "Acuerdo de Practicante",
    "deleteAccount": "Eliminar cuenta",
    "mission": "Misión",
    "ethicsCode": "Código de ética",
    "referral": "Programa de referidos",
    "copyright": "© 2026 Agapella. Todos los derechos reservados.",
    "legalEntity": "En Rusia, el servicio lo presta JSC «Tsifrovaya II Transformatsiya» (АО «Цифровая ИИ Трансформация») · INN 9729424798 · KPP 772901001 · OGRN 1267700307841 · c. Bogdanova 10, edif. 2, local 2/3, Moscú, 119618, Rusia",
    "legalEntityIntl": "El servicio lo presta AGAPE.IO Limited · Room 1803, 18/F, Lucky Centre, No. 165–171 Wan Chai Road, Wan Chai, Hong Kong",
    "designedFor": "Diseñado para la serenidad."
  },
  "cookies": {
    "title": "Cookies y contadores",
    "description": "Las cookies hacen que funcionen el inicio de sesión, tus preferencias y las estadísticas básicas de visitas. Los demás contadores de analítica y de marketing se cargan solo con tu consentimiento, y puedes elegir por categoría.",
    "policyLink": "Política de Privacidad, sección 15",
    "acceptAll": "Aceptar",
    "necessaryOnly": "Mantener solo las necesarias",
    "decline": "Rechazar",
    "customize": "Configurar",
    "settingsTitle": "Configuración de cookies",
    "settingsIntro": "Elige qué cookies y contadores se pueden usar. Puedes cambiarlo en cualquier momento: el enlace «Configuración de cookies» está al final de la página y en los ajustes del perfil.",
    "alwaysOn": "Siempre activas",
    "necessary": {
      "title": "Necesarias",
      "description": "Inicio de sesión, seguridad, mantenimiento de la sesión y estadísticas básicas de visitas, con las que vemos cómo funciona la plataforma."
    },
    "functional": {
      "title": "Funcionales",
      "description": "Tus preferencias en este dispositivo: tema, idioma, volumen, sugerencias ocultas. No se comparten con terceros."
    },
    "analytics": {
      "title": "Analíticas",
      "description": "Contadores de tráfico de terceros adicionales. Muestran qué páginas se abren y qué conviene mejorar."
    },
    "marketing": {
      "title": "De marketing",
      "description": "Contadores de servicios publicitarios. Muestran qué anuncios traen personas a la plataforma."
    },
    "providers": {
      "metrika": "Yandex Metrica",
      "ga4": "Google Analytics",
      "vk": "píxel de VK"
    },
    "providersList": "Se cargan: {{list}}",
    "providersNone": "Ahora no hay contadores en esta categoría.",
    "reloadHint": "Un contador desactivado deja de funcionar al recargar la página.",
    "save": "Guardar elección",
    "close": "Cerrar"
  },
  "authCta": {
    "onboarding": {
      "heading": "Guarda tus preferencias",
      "body": "Regístrate para guardar tus preferencias y recibir recomendaciones personalizadas de sesiones."
    },
    "gatedAction": {
      "heading": "Únete a Agapella",
      "body": "Crea una cuenta gratuita para desbloquear esta función."
    }
  },
  "time": {
    "now": "ahora",
    "justNow": "justo ahora",
    "minsAgo": "hace {{count}}m",
    "hoursAgo": "hace {{count}}h",
    "daysAgo": "hace {{count}}d",
    "min": "MIN",
    "minutes": "min"
  },
  "calendar": {
    "button": "CALENDARIO",
    "google": "Google Calendar",
    "downloadIcs": "Descargar .ics",
    "addToCal": "Agregar al Cal",
    "downloadFailed": "No se pudo descargar el archivo de calendario. Por favor, inténtalo de nuevo.",
    "googleFailed": "No se pudo abrir Google Calendar. Por favor, inténtalo de nuevo."
  },
  "errors": {
    "title": "Error",
    "generic": "Algo salió mal. Por favor, inténtalo de nuevo.",
    "failedToPost": "No se pudo crear la publicación",
    "notFound": "No encontrado"
  },
  "events": {
    "liveNow": "LIVE",
    "live": "EN VIVO",
    "upcoming": "PRÓXIMAMENTE",
    "notifyMe": "NOTIFICARME",
    "notified": "NOTIFICADO",
    "registered": "REGISTRADO",
    "register": "REGISTRARSE",
    "subscribed": "SUSCRITO",
    "online": "En línea",
    "onlineEvent": "Evento en Línea",
    "locationTba": "Por confirmar",
    "locationTbaFull": "Ubicación por confirmar",
    "spotsAvailable": "{{left}} / {{total}} lugares disponibles",
    "unlimitedSpots": "Lugares ilimitados",
    "percentFilled": "% lleno",
    "aboutThisEvent": "SOBRE ESTE EVENTO",
    "contact": "CONTACTO",
    "featured": "DESTACADO"
  },
  "eventContact": {
    "title": "Contactar al Organizador",
    "aboutPrefix": "Sobre: {{title}}",
    "messageSent": "Mensaje enviado.",
    "messageDelivered": "Tu mensaje ha sido entregado. Responderán en breve.",
    "nameLabel": "TU NOMBRE",
    "namePlaceholder": "Ingresa tu nombre",
    "emailLabel": "EMAIL (OPCIONAL)",
    "emailPlaceholder": "tu@email.com",
    "messageLabel": "MENSAJE",
    "messagePlaceholder": "Tu mensaje...",
    "emailFallback": "O escribe directamente a: {{email}}",
    "validationError": "Por favor completa tu nombre y mensaje",
    "sendFailed": "No se pudo enviar el mensaje. Por favor, inténtalo de nuevo."
  },
  "chat": {
    "folder": {
      "ai": "AI",
      "circles": "Círculos",
      "friends": "Personas"
    },
    "sidebar": {
      "searchPlaceholder": "Buscar",
      "empty": "Vacío por ahora. Los chats aparecerán cuando ocurran."
    },
    "header": {
      "aiTyping": "escribiendo",
      "typing": "escribiendo…",
      "aiSubtitle": "Amigo AI",
      "members": "{{count}} miembros",
      "online": "en línea"
    },
    "aboutEvent": "Sobre este Evento",
    "liveSession": "Sesión en Vivo",
    "byMaster": "Por {{name}}",
    "defaultDescription": "Únete a {{name}} para una práctica transformadora en vivo...",
    "reconnecting": "Reconectando...",
    "disconnected": "Chat desconectado",
    "firstMessage": "Sé el primero en compartir tus pensamientos...",
    "sayHello": "Saluda a la comunidad",
    "host": "ANFITRIÓN",
    "offering": "HACER UNA OFRENDA",
    "thankYou": "Gracias por tu ofrenda de ${{amount}} 🙏",
    "customAmount": "Monto Personalizado",
    "placeholder": "Escribe en el chat de la práctica…",
    "archiveNotice": "La sesión en vivo fue cancelada. El chat está cerrado."
  },
  "profile": "PERFIL",
  "contact": {
    "title": "ESTAMOS EN CONTACTO",
    "subtitle": "Nos alegra conversar y recibir tus comentarios. ¡Escríbenos!",
    "email": "Email",
    "instagram": "Instagram",
    "youtube": "YouTube",
    "teamTitle": "¡Agape a todos!",
    "teamText": "¡Hola! Somos el equipo distribuido de la plataforma Agapella: trabajamos desde distintos países del mundo, en distintas zonas horarias, más allá de la geografía. Si tienes preguntas, dificultades al usar la plataforma, has notado un error o cualquier infracción de las reglas o del código de ética de la plataforma por parte de un maestro u otros usuarios, por favor, escríbenos. Si tu experiencia con la plataforma, los maestros o las comunidades te dejó impresiones cálidas y te dio sensación de apoyo y amor, por favor, comparte tus emociones y observaciones. Junto contigo y gracias a tus comentarios desarrollamos la plataforma."
  },
  "room": {
    "share": {
      "subject": "Únete a la sesión en vivo «{{title}}» en Agapella",
      "message": "Únete a la sesión en vivo «{{title}}» en Agapella\n{{url}}",
      "untitled": "Sesión en vivo",
      "toFeed": "A mi muro",
      "toFeedHint": "El anuncio de esta sesión en vivo aparecerá en tu muro",
      "toFeedNoAnnouncement": "Esta sesión en vivo no tiene anuncio en el muro, por eso todavía no se puede repostear",
      "toFeedLookupFailed": "No se pudo comprobar si hay anuncio en el muro. Cierra el menú y vuelve a abrirlo",
      "practiceToFeed": "Compartir la práctica en mi muro",
      "practiceToFeedHint": "Práctica de la biblioteca: «{{title}}»",
      "inApp": "En Agapella"
    },
    "reflection": {
      "banner": "Reflexión · {{time}} restante"
    },
    "completed": {
      "banner": "Práctica completada · la sesión en vivo sigue abierta"
    },
    "countdown": {
      "banner_one": "Empezamos en {{count}} s — prepara tu espacio",
      "banner_other": "Empezamos en {{count}} s — prepara tu espacio"
    },
    "tile": {
      "cameraOff": "Cámara apagada",
      "videoOnStage": "Vídeo en escena",
      "nowPlaying": "Ahora suena",
      "videoPractice": "Práctica en video"
    },
    "meta": {
      "by": "por {{name}}",
      "rec": "REC",
      "raised": "{{count}} con la mano levantada"
    },
    "roster": {
      "cohost": "Anfitrión"
    },
    "participant": {
      "joined": "Se unió a las {{time}}",
      "handRaised": "Mano levantada",
      "close": "Cerrar",
      "roleHost": "Anfitrión",
      "roleParticipant": "Participante",
      "micOff": "Silenciado",
      "micOn": "Hablando",
      "videoOn": "Cámara activa",
      "audioOnly": "Solo audio"
    },
    "archive": {
      "chatTitle": "Chat",
      "readOnly": "solo lectura"
    },
    "panel": {
      "chat": "Chat",
      "participants": "Participantes · {{count}}"
    },
    "ended": {
      "banner": "Sesión finalizada"
    },
    "silent": {
      "banner": "Práctica en silencio: el anfitrión no ha permitido encender el micrófono ni la cámara",
      "micDisabled": "Micrófono apagado: hay una práctica en silencio",
      "camDisabled": "Cámara apagada: hay una práctica en silencio",
      "camBlockedByHost": "El anfitrión ha desactivado las cámaras de los participantes",
      "micBlockedByHost": "El anfitrión ha desactivado los micrófonos de los participantes",
      "camBlockedForYou": "El anfitrión ha apagado tu cámara"
    },
    "locked": {
      "micStageFull": "Ahora todos los lugares para intervenir están ocupados",
      "camStageFull": "Ahora todos los lugares para intervenir están ocupados",
      "micUnavailable": "El micrófono no está disponible ahora",
      "camUnavailable": "La cámara no está disponible ahora"
    },
    "seat": {
      "devicesNotAllowed": "El anfitrión no ha permitido micrófonos ni cámaras",
      "stageFull": "Ahora todos los lugares para intervenir están ocupados. Intenta activarte cuando se libere un lugar",
      "unavailable": "Ahora no se pudo activar. Inténtalo de nuevo un poco más tarde",
      "network": "No se pudo activar: no hay conexión con el servidor. Inténtalo de nuevo"
    },
    "floorGranted": {
      "micHint": "El anfitrión te ha dado la palabra. Activa el micrófono para que te escuchen"
    },
    "spectator": {
      "watchingAsGuest": "Estás viendo como invitado",
      "joinedAs": "Has entrado como {{name}}",
      "signIn": "Iniciar sesión",
      "signInToParticipate": "Inicia sesión para participar",
      "signInToSpeakChat": "Inicia sesión para hablar y escribir",
      "signInToChat": "Inicia sesión para escribir en el chat",
      "signInToRaiseHand": "Inicia sesión para levantar la mano",
      "publishDenied": "Tienes la palabra, pero el micrófono aún no se ha abierto. Recarga la página o pide al anfitrión que te dé la palabra de nuevo",
      "viewersWithoutAccount": "Viendo sin cuenta: {{count}}",
      "moreViewers": "y {{count}} más que llegaron antes que tú",
      "sectionTitle": "OYENTES",
      "roleLabel": "Oyente"
    },
    "chat": {
      "placeholder": "Escribe un mensaje…",
      "connecting": "El chat se está conectando…",
      "freeze": "Desactivar el chat",
      "unfreeze": "Activar el chat",
      "frozenPlaceholder": "El anfitrión ha desactivado el chat",
      "mutedPlaceholder": "El anfitrión ha limitado tus mensajes en el chat",
      "mutedUntilPlaceholder": "El anfitrión ha limitado tus mensajes en el chat hasta las {{time}}",
      "emoji": "Emoji",
      "pinnedTitle": "Mensaje fijado",
      "unpin": "Desfijar",
      "pinFailed": "No se pudo cambiar el mensaje fijado. Inténtalo de nuevo.",
      "deleteConfirmTitle": "¿Eliminar el mensaje?",
      "deleteConfirmBody": "Desaparecerá para todos los participantes de la sesión en vivo. No se puede deshacer.",
      "deleteConfirm": "Eliminar",
      "deleteFailed": "No se pudo eliminar el mensaje. Inténtalo de nuevo.",
      "attach": {
        "attach": "Adjuntar un archivo",
        "uploading": "Subiendo…",
        "retry": "Reintentar",
        "remove": "Quitar {{name}}",
        "lessThanMb": "menos de 1 MB",
        "mb": "{{n}} MB",
        "defaultName": "archivo",
        "defaultImage": "Imagen",
        "defaultFile": "Documento",
        "andMore": "{{list}} y otros",
        "unsupported": "Este archivo no se puede enviar. Sirven imágenes ({{images}}) y documentos ({{docs}}).",
        "imageTooLarge": "Las imágenes pueden pesar hasta {{limit}}; esta pesa {{size}}. Elige un archivo más pequeño o comprime este.",
        "fileTooLarge": "Los documentos pueden pesar hasta {{limit}}; este pesa {{size}}. Elige un archivo más pequeño.",
        "tooMany": "Un mensaje admite hasta {{max}} archivos. Envía estos y continúa en el siguiente.",
        "uploadFailed": "El archivo no se subió. Inténtalo de nuevo.",
        "sendFailed": "El mensaje no se envió. Intenta enviarlo de nuevo.",
        "refusedForbidden": "Ahora mismo no puedes adjuntar archivos aquí.",
        "refusedInvalid": "Este archivo ya se envió o caducó. Quítalo y adjúntalo de nuevo.",
        "refusedFrozen": "El anfitrión desactivó el chat, así que el mensaje no se envió.",
        "refusedMuted": "El anfitrión ha limitado temporalmente tus mensajes en el chat, así que el mensaje no se envió.",
        "unavailable": "{{name}} ya no está disponible",
        "openImage": "Abrir imagen: {{name}}",
        "downloadFile": "Descargar documento: {{name}}",
        "kb": "{{n}} KB",
        "progress": "{{loaded}} de {{total}}",
        "statusUploading": "Subiendo {{count}} de {{total}}",
        "statusQueued": "el mensaje se enviará cuando todo esté subido",
        "queueFailed": "No todo se subió: reintenta o quita el archivo con error",
        "queueRejected": "Primero quita el archivo que no fue aceptado; después se enviará el mensaje.",
        "failedShort": "No se subió",
        "retryShort": "Reintentar",
        "downloadAll": "Descargar todo · {{size}}",
        "unavailableShort": "El archivo ya no está disponible",
        "serverUnsupported": "Este formato de archivo no es compatible.",
        "serverTooLarge": "El archivo es demasiado grande.",
        "replaceHint": "Quítalo y elige otro archivo.",
        "failureLine": "{{name}} — {{reason}}",
        "failedIcon": "Archivo no aceptado: {{reason}}"
      }
    },
    "system": {
      "welcome": "Bienvenido a la sesión en vivo",
      "guestWelcome": "Hola, me alegra que estés aquí, en Agapella. Estás viendo esta sesión en vivo como invitado: inicia sesión o regístrate para escribir en el chat y levantar la mano. No se interrumpirá.",
      "practiceBegins": "🙏 La práctica comienza ahora",
      "sessionBegins": "🙏 La sesión en vivo comienza ahora",
      "practiceComplete": "🧘 Práctica completada. Entrando en período de reflexión...",
      "practiceCompleteStay": "🧘 Práctica completada. La sesión en vivo sigue abierta — puedes conversar o elegir otra práctica.",
      "sessionComplete": "✨ Sesión completada. Gracias por practicar juntos.",
      "plannedTimeElapsed": "⏳ El tiempo previsto ha terminado. La sesión en vivo sigue abierta — finalízala manualmente o sigue conversando.",
      "chatConnecting": "El chat se está conectando — inténtalo en un momento.",
      "chatSendFailed": "El mensaje no se envió: se perdió la conexión. El texto volvió al campo de entrada.",
      "chatRateLimited": "El mensaje no se envió: demasiados seguidos. Espera un par de segundos y envíalo de nuevo.",
      "chatMuted": "El anfitrión ha limitado temporalmente tus mensajes en el chat. No se envió; el texto sigue en el campo de entrada.",
      "nowPlaying": "🎵 Reproduciendo: {{title}}",
      "spectating": "Viendo como {{name}}",
      "handRaiseFailed": "No se pudo levantar la mano — se perdió la conexión. Inténtalo de nuevo.",
      "handLowerFailed": "No se pudo bajar la mano — se perdió la conexión. Inténtalo de nuevo."
    },
    "leave": {
      "titleHost": "Finalizar práctica",
      "titleGuest": "Salir de la sesión en vivo",
      "bodyHost": "¿Finalizar la práctica y cerrar la sesión en vivo para todos? Esta acción no se puede deshacer.",
      "bodyGuest": "¿Salir de la sesión en vivo? La práctica continúa — los demás participantes se quedan. Puedes volver usando el enlace.",
      "stay": "Quedarme",
      "end": "Finalizar",
      "leave": "Abandonar",
      "navGuard": "Estás saliendo de la página durante una práctica. La sesión en vivo continuará — los invitados permanecerán en ella. ¿Salir?",
      "navGuardWaiting": "La sesión en vivo aún no ha comenzado — estás saliendo de la sala de espera. La sala sigue abierta y los invitados esperarán el inicio. ¿Salir?",
      "handover": {
        "title": "Estás saliendo de la sesión",
        "body": "La sesión puede continuar si cedes el control a alguien presente. O puedes finalizarla para todos.",
        "bodyEmpty": "No hay a quién ceder el control: estás solo en la sesión. Puedes quedarte o finalizarla para todos.",
        "handOver": "Ceder el control y salir",
        "endForAll": "Finalizar la sesión para todos",
        "stay": "Quedarme en la sesión",
        "pickTitle": "Quién continúa",
        "pickBody": "Elige quién seguirá dirigiendo la sesión. Recibirá una invitación para ser anfitrión y saldrás cuando la acepte. Tú sigues siendo el autor: el anuncio y las grabaciones siguen siendo tuyos.",
        "confirm": "Invitar y salir",
        "handingOver": "Enviando…",
        "pickBodyHost": "Esta persona ya es anfitriona — no hace falta invitación. Saldrás de inmediato y la sesión Live continuará. Sigues siendo el autor: el anuncio y las grabaciones se quedan contigo.",
        "confirmHost": "Transferir y salir",
        "leavingWithHost": "Saliendo…",
        "back": "Atrás",
        "someone": "Participante",
        "errorGone": "Esa persona ya salió de la sesión. Elige a otra.",
        "errorNotHere": "Esa persona no está en la sesión. Actualiza la lista y elige a otra.",
        "errorFailed": "No se pudo ceder el control. Sigues siendo el anfitrión: inténtalo de nuevo.",
        "bodyNotAllowed": "El control de esta sesión no se puede ceder: los anfitriones adicionales solo existen en las sesiones de un maestro. Puedes quedarte o finalizarla para todos.",
        "errorNotAllowed": "El control de esta sesión no se puede ceder: los anfitriones adicionales solo existen en las sesiones de un maestro. Puedes quedarte o finalizarla para todos.",
        "bodyWithHosts": "Otros anfitriones siguen en la sesión: continuará sin ti. O puedes finalizarla para todos.",
        "leaveOnly": "Salir — los anfitriones continúan",
        "waitingTitle": "Esperando respuesta",
        "waiting": "{{name}} ha recibido la invitación para ser anfitrión. Saldrás en cuanto la acepte.",
        "cancelWait": "Cancelar y quedarme",
        "errorDeclined": "{{name}} la rechazó. Elige a otra persona o finaliza la sesión.",
        "errorExpired": "La invitación para {{name}} ya no es válida. Elige de nuevo."
      },
      "failedTitle": "No se pudo salir",
      "failedBody": "Se perdió la conexión con el servidor y la salida no se guardó. Sigues en la sesión Live: intenta salir de nuevo."
    },
    "status": {
      "connecting": "Conectando a la sesión en vivo…",
      "rateLimited": "Demasiadas solicitudes — volvemos a intentarlo…",
      "unavailable": "Sesión en vivo no disponible",
      "notFound": "Sesión en vivo no encontrada o finalizada",
      "removed": "Te eliminaron de esta sesión en vivo",
      "goHome": "Ir al inicio",
      "linkCopied": "Enlace de la sesión en vivo copiado al portapapeles",
      "linkTitle": "Enlace de la sesión en vivo",
      "inviteTitle": "Enlace de invitación"
    },
    "actions": {
      "end": "FINALIZAR",
      "leave": "SALIR",
      "stepOut": "SALIR A LA PLATAFORMA",
      "mediaError": "No se pudo cambiar el contenido",
      "mediaAudioLocked": "La música de fondo no está disponible en esta sesión Live. Puedes elegir una práctica de la biblioteca en la pestaña Vídeo.",
      "mediaAudioNotAllowed": "La música de fondo no está disponible en esta sesión Live.",
      "mediaNoRights": "No tienes permiso para cambiar el contenido en esta sesión Live.",
      "mediaPracticeUnavailable": "Esta práctica no se puede mostrar en una sesión Live.",
      "error": "Error"
    },
    "kicked": {
      "title": "Eliminado",
      "body": "El anfitrión te eliminó de esta sesión en vivo."
    },
    "defaultTitle": "Sesión en vivo",
    "createFailed": "No se pudo crear la sesión en vivo",
    "tryAgain": "Inténtalo de nuevo.",
    "sessionMoved": {
      "title": "Sesión transferida",
      "body": "Entraste a esta sesión en vivo desde otro dispositivo. Esta sesión ha sido transferida.",
      "close": "Cerrar",
      "rejoin": "Unirse aquí"
    },
    "kickParticipant": {
      "title": "Eliminar participante",
      "message": "¿Eliminar a {{name}} de la sesión en vivo?",
      "confirm": "Eliminar",
      "cancel": "Cancelar",
      "button": "Eliminar"
    },
    "returnHint": {
      "titleScheduled": "La sesión en vivo está programada",
      "bodyScheduled": "Puedes salir a la plataforma y volver a esta sesión en vivo más tarde desde el bloque «Próximo evento» de tu perfil.",
      "titleReady": "La sesión en vivo está lista",
      "bodyReady": "Puedes salir y volver a ella desde tu perfil antes de que empiece la sesión en vivo.",
      "dismiss": "Entendido",
      "close": "Cerrar"
    },
    "allowParticipantCamera": "Permitir cámara",
    "webRtcUnsupported": {
      "text": "Parece que este navegador no admite el sonido y el vídeo de la sesión Live. Abre el enlace en Safari o Chrome y, si tu iPhone tiene activado el Modo de aislamiento, desactívalo para este sitio."
    },
    "poorLink": {
      "text": "La conexión es inestable ahora y el sonido puede retrasarse. Si usas una VPN, prueba sin ella: normalmente se oye mejor.",
      "dismiss": "Ocultar"
    },
    "hosts": {
      "inviteTitle": "¿Ser anfitrión?",
      "inviteBody": "{{name}} te invita a dirigir esta sesión en vivo. Todos los anfitriones tienen las mismas herramientas: práctica, audio de fondo, participantes, chat, pantalla, grabación y finalizar la sesión.",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "accepting": "Aceptando…",
      "declining": "Rechazando…",
      "becameHost": "{{name}} ahora es anfitrión",
      "noLongerHost": "{{name}} ya no es anfitrión",
      "youAreHost": "Ahora eres anfitrión",
      "youAreNoLongerHost": "Ya no eres anfitrión",
      "invited": "{{name}} ha recibido la invitación para ser anfitrión",
      "declined": "{{name}} rechazó ser anfitrión",
      "someone": "Participante",
      "errors": {
        "registration_required": "Solo un participante con cuenta puede ser anfitrión. El invitado debe iniciar sesión o registrarse.",
        "already_host": "Este participante ya es anfitrión.",
        "not_present": "El participante ya salió de la sesión.",
        "not_pending": "La invitación ya no es válida.",
        "stage_full": "No hay lugares libres en el escenario: primero retira la palabra a alguien.",
        "session_ended": "La sesión en vivo ya terminó.",
        "not_allowed": "En esta sesión no se pueden añadir anfitriones: es posible solo en las sesiones de un maestro.",
        "failed": "Algo salió mal. Inténtalo de nuevo."
      }
    }
  },
  "security": {
    "title": "Seguridad de inicio",
    "subtitle": "Añade un passkey para entrar sin contraseña — huella, rostro o llave del dispositivo.",
    "addPasskey": "Añadir passkey",
    "connectedDevices": "DISPOSITIVOS CONECTADOS",
    "empty": "Aún no tienes passkeys. Añade uno y olvídate de la contraseña.",
    "unsupportedBrowser": "Este navegador no admite passkeys. Abre Agapella en Chrome, Safari o Firefox actualizado.",
    "unsupportedNative": "Los passkeys solo funcionan en la versión web por ahora. Abre agapella.io en el navegador.",
    "unavailableOnServer": "Los passkeys aún no están habilitados en este servidor. Vuelve pronto.",
    "loading": "Cargando…",
    "device": "Dispositivo",
    "added": "añadido ",
    "lastUsed": "último uso: ",
    "password": {
      "sectionTitle": "CONTRASEÑA",
      "setTitle": "Establecer una contraseña",
      "setSubtitle": "Ahora entras con Google o Apple. Establece una contraseña para poder entrar también con tu email.",
      "changeTitle": "Cambiar contraseña",
      "changeSubtitle": "Enviaremos un enlace a {{email}} para que establezcas una nueva.",
      "sendButton": "Enviarme un enlace",
      "sending": "Enviando…",
      "sentTitle": "Revisa tu correo",
      "sentBody": "Enviamos un enlace a {{email}}. Ábrelo para establecer tu contraseña — es válido por una hora.",
      "error": "No pudimos enviar el enlace. Inténtalo de nuevo en un momento."
    },
    "mcp": {
      "sectionTitle": "Acceso para clientes de IA",
      "title": "Tus sesiones en Claude y otros clientes de IA",
      "subtitle": "Una clave permite a un cliente de IA leer tus sesiones: la lista, las transcripciones de grabaciones y el chat, exactamente lo que ves aquí. Solo lectura. Puedes revocar una clave en cualquier momento.",
      "mint": "Crear clave",
      "minting": "Creando…",
      "empty": "Aún no hay claves.",
      "keyDefaultLabel": "Clave",
      "created": "Creada ",
      "lastUsed": "usada ",
      "never": "nunca",
      "revoked": "revocada",
      "show": "Mostrar",
      "hide": "Ocultar",
      "copy": "Copiar",
      "copied": "Copiado",
      "revoke": "Revocar",
      "revokeConfirm": "¿Revocar la clave {{key}}? El cliente de IA que la use perderá el acceso en un minuto.",
      "configTitle": "Conexión",
      "configHint": "Añade esto a la configuración de tu cliente MCP (Claude Code, Claude Desktop):",
      "unavailable": "La creación de claves no está disponible en el servidor ahora mismo.",
      "error": "Algo salió mal. Inténtalo de nuevo."
    }
  },
  "kula": {
    "globalCommunity": "COMUNIDAD GLOBAL",
    "circleTitle": "Comunidad",
    "circleSub": "Encuentra practicantes. Únete a círculos. Caminad juntos.",
    "searchCircles": "Buscar círculos...",
    "circlesSection": "Círculos de la comunidad",
    "peopleSection": "Personas",
    "open": "ABRIR",
    "join": "UNIRSE",
    "members": "MIEMBROS",
    "allCategories": "Todos",
    "create": "Crear",
    "noCircles": "No se encontraron círculos. Prueba con otra categoría o búsqueda.",
    "noCirclesFound": "No se encontraron círculos",
    "noMembersFound": "No se encontraron miembros",
    "heroPhase1Title": "Diseña tu entorno.",
    "heroPhase1Scroll": "EXPLORAR",
    "heroPhase2Title": "Encuentra a los tuyos",
    "heroPhase2Sub": "Únete a círculos según tus intereses y filosofía. Practica y evoluciona junto a quienes comparten tus valores.",
    "categories": {
      "meditation": "Meditación",
      "psychology": "Psicología",
      "philosophy": "Filosofía",
      "denominations": "Confesiones",
      "body_practices": "Prácticas corporales",
      "spiritual_practices": "Prácticas espirituales",
      "morning_evening": "Mañana y noche",
      "leadership": "Liderazgo",
      "motivation": "Motivación"
    }
  },
  "aboutPlatform": {
    "title": "Sobre Agapella",
    "subtitle": "Agapella es una plataforma para la salud mental, el bienestar psicológico y el crecimiento interior, para la interacción viva entre maestros y participantes afines.",
    "tabs": {
      "participants": "Para participantes",
      "masters": "Para maestros"
    },
    "showMore": "Mostrar todo",
    "showLess": "Mostrar menos",
    "missionCta": "Más sobre la misión de la plataforma",
    "banner": {
      "title": "Agapella, un espacio de participación y acción conjunta",
      "text": "Agapella somos «nosotros»: alumnos y maestros de distintas escuelas y tradiciones se unen para crear una comunidad consciente y solidaria."
    },
    "error": "No se pudo cargar la página. Inténtalo de nuevo más tarde.",
    "retry": "Reintentar"
  },
  "referral": {
    "title": "Programa de referidos",
    "lead": "Comparte tu enlace de Agapella. Cuando las personas que traes compran cursos y programas de maestros, una parte del importe vuelve a ti — en dinero real.",
    "leadPoints": "Comparte tu enlace de Agapella con quienes puedan sentirlo cercano. Las invitaciones pueden dar puntos: sirven como descuento dentro de Agapella y no se cambian por dinero.",
    "pointsNote": "Las reglas para obtener puntos aparecerán aquí cuando estén aprobadas. Las condiciones están en los Términos de uso.",
    "yourLink": "Tu enlace",
    "copyLink": "Copiar enlace",
    "clicks": "Clics",
    "registrations": "Registros",
    "buyers": "Compradores",
    "earned": "Ganado",
    "available": "Disponible para pago",
    "paid": "Pagado",
    "join": "Unirse al programa",
    "enrolling": "Uniéndote",
    "enrollFailed": "No se pudo unir al programa. Inténtalo de nuevo.",
    "termsAccept": "Acepto las condiciones del programa de referidos",
    "termsRead": "Leer las condiciones",
    "termsHide": "Ocultar las condiciones",
    "termsLoadFailed": "No se pudo cargar el texto. Inténtalo de nuevo.",
    "termsUnavailable": "Las condiciones del programa aún se están preparando. Podrás unirte cuando se publiquen.",
    "termsReacceptTitle": "Condiciones del programa de referidos",
    "termsReacceptLead": "Para recibir pagos, acepta la versión vigente de las condiciones. Mientras tanto, las recompensas de tu enlace se siguen acumulando.",
    "termsReacceptCta": "Aceptar las condiciones",
    "termsReacceptSaving": "Guardando…",
    "recentAccruals": "Últimas ganancias",
    "level1": "Primer nivel",
    "level2": "Segundo nivel",
    "statePending": "Disponible más adelante",
    "statePendingUntil": "Disponible el",
    "stateAvailable": "Disponible para pago",
    "statePaid": "Pagado",
    "stateReturned": "Devuelto",
    "stateOnReview": "En revisión",
    "nextPayout": "Próximo pago —",
    "payoutsPaused": "Los pagos todavía no están disponibles. Tus recompensas se siguen acumulando y no se pierden: te avisaremos cuando puedas retirarlas.",
    "payoutDetails": {
      "entry": "Datos de pago",
      "entryEmpty": "sin completar",
      "entryFilled": "completados",
      "title": "Datos de pago",
      "lead": "Los pagos en rublos necesitan tus datos fiscales y una cuenta bancaria. Se envían a un servidor en Rusia y se quedan allí: esta pantalla los manda directamente, sin pasar por el resto de la plataforma.",
      "unavailable": "Todavía no recogemos datos de pago. Te avisaremos cuando se pueda.",
      "fieldInn": "Número fiscal (INN)",
      "fieldBank": "Datos bancarios",
      "filledPlaceholder": "completado: escríbelo de nuevo para cambiarlo",
      "inn": "Número fiscal (INN)",
      "beneficiaryName": "Nombre del titular de la cuenta",
      "bankAccount": "Número de cuenta",
      "bankBic": "BIC del banco",
      "bankName": "Nombre del banco",
      "taxStatus": "Situación fiscal",
      "taxStatuses": {
        "individual": "Persona física",
        "self_employed": "Autónomo (NPD)",
        "sole_trader": "Empresario individual"
      },
      "consentText": "Doy mi consentimiento para el tratamiento de mis datos personales con el fin de realizar los pagos y cumplir las obligaciones fiscales. Puedo retirarlo en cualquier momento.",
      "save": "Guardar",
      "saving": "Guardando…",
      "saved": "Guardado.",
      "revoke": "Retirar el consentimiento",
      "erase": "Eliminar mis datos",
      "revokedNote": "Consentimiento retirado y datos borrados. Los pagos en rublos están en pausa.",
      "rightsNote": "Retirar el consentimiento detiene los pagos y borra los datos. El historial de ingresos se mantiene: hace falta para la contabilidad.",
      "errors": {
        "INVALID_INN": "El número fiscal no cuadra con su dígito de control. Revisa las cifras.",
        "INVALID_SNILS": "El número de seguro no cuadra con su dígito de control. Revisa las cifras.",
        "INVALID_BIC": "El BIC tiene nueve dígitos.",
        "INVALID_ACCOUNT": "La cuenta y el BIC no concuerdan. Revisa ambos.",
        "INVALID_TAX_STATUS": "Elige una situación fiscal.",
        "CONSENT_REQUIRED": "Sin tu consentimiento no podemos guardarlo.",
        "INN_ALREADY_USED": "Ese número fiscal ya está vinculado a otra cuenta.",
        "TAX_CONTOUR_NOT_CONFIGURED": "Todavía no recogemos datos de pago.",
        "UNKNOWN": "No se pudo guardar. Inténtalo de nuevo."
      }
    }
  },
  "dates": {
    "monthsFull": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "monthsShort": [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic"
    ],
    "monthsGenitive": [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "weekdaysShort": [
      "Dom",
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb"
    ],
    "dayMonth": "{{day}} de {{month}}",
    "dayMonthShort": "{{day}} {{month}}",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "yesterday": "Ayer",
    "dayMonthAtTime": "{{date}} a las {{time}}"
  },
  "a11y": {
    "openMenu": "Abrir menú",
    "toggleTheme": "Cambiar tema",
    "back": "Atrás",
    "close": "Cerrar",
    "menu": "Menú"
  },
  "permissions": {
    "galleryTitle": "Sin acceso",
    "galleryBody": "Permite el acceso a la galería en los ajustes."
  },
  "postDiscussion": {
    "open": "Comentar",
    "openA11y": "Abrir la conversación de la publicación",
    "create": "Crear una conversación",
    "createHint": "La conversación vinculada aparece en los chats del maestro. En una publicación para suscriptores, solo ellos pueden entrar."
  },
  "repost": {
    "title": "Repostear en tu muro",
    "placeholder": "Añade unas palabras tuyas (opcional)",
    "publish": "Publicar",
    "done": "Publicado en tu muro",
    "signIn": "Inicia sesión para repostear en tu muro.",
    "action": "Repost",
    "actionA11y": "Repostear en tu muro",
    "kindPost": "Publicación",
    "kindAnnouncement": "Anuncio",
    "kindEvent": "Evento",
    "kindPractice": "Práctica",
    "kindRecording": "Grabación",
    "kindRoom": "Sesión en vivo",
    "unknownAuthor": "Autor",
    "openOriginal": "Abrir el original",
    "unavailable": "El original fue eliminado o no está disponible",
    "lockedSubscription": "Disponible completo para los suscriptores del maestro",
    "lockedPurchase": "Disponible en el programa del maestro",
    "subscribeCta": "Suscribirse",
    "purchaseCta": "Abrir el programa",
    "stateCancelled": "Cancelado",
    "stateLive": "En directo",
    "stateEnded": "Finalizado",
    "durationMin": "{{n}} min",
    "errNotAllowed": "Esto no se puede repostear: evento, directo o práctica privados.",
    "errNotFound": "El original no se encontró o ya no está disponible.",
    "errOpen": "No se pudo preparar la publicación. Comprueba la conexión e inténtalo de nuevo.",
    "errPrivateRoom": "Esta sesión en vivo es privada, por eso no se puede compartir en el muro.",
    "errCancelledRoom": "Este encuentro fue cancelado, por eso no se puede compartir en el muro."
  },
  "rewardReactions": {
    "locked": "Esta reacción es un regalo por completar tu perfil. Complétalo antes del {{date}} y se desbloqueará.",
    "rewardOnly": "Esta reacción es un regalo por completar el perfil durante el primer mes.",
    "unlocked": "Tu perfil está completo: ahora tienes tres reacciones exclusivas. Ya están entre las reacciones.",
    "lockedA11y": "{{label}}: se desbloquea al completar el perfil"
  },
  "eventReport": {
    "tell": "Contar cómo fue",
    "tellHint": "El informe aparecerá en tu feed",
    "published": "Informe del evento publicado",
    "openReport": "Abrir el informe",
    "overline": "Informe del evento",
    "placeholder": "Cuenta cómo fue todo",
    "detach": "No vincular al evento",
    "loading": "Cargando el evento…",
    "loadFailed": "No se pudo cargar el evento.",
    "retry": "Reintentar",
    "postChip": "Informe del evento",
    "openEvent": "Abrir el evento del que trata este informe",
    "blocked": {
      "deleted": "Este evento se eliminó, así que el informe no se puede vincular. Quita el vínculo y el texto se publicará como una publicación normal.",
      "not_own": "Este evento es de otro maestro: solo puedes contar sobre los tuyos.",
      "online": "Los informes son para eventos presenciales, y este fue en línea.",
      "not_ended": "El evento aún no ha terminado: podrás contar cómo fue cuando acabe.",
      "already_reported": "Ya hay un informe publicado sobre este evento; no hace falta otro."
    }
  }
}
